import React, { useState } from 'react';
import ActAttachmentModal, { AttachmentModalVariant } from 'app/edozvola/cases/case-acts/attachment-modal/act-attachment-modal';
import PreviewActsTable from 'app/edozvola/cases/case-acts/preview-acts-table';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import { useAppSelector } from 'app/config/store';
import { generateEarhivaConfirmationQuery } from 'app/edozvola/cases/case-acts/service/case-acts.queries';
import { useParams } from 'react-router-dom';
import { FullScreenLoader } from 'app/shared/loader/fullscreen-loader';

const PreviewActs = () => {
  const { id: uuid } = useParams<{ id: string }>();
  const [idCaseActForAttachments, setIdCaseActForAttachments] = useState<string | null>(null);
  const [actAttachmentVariant, setActAttachmentVariant] = useState<AttachmentModalVariant>();
  const canCreateEarhivaConfirmation = useAppSelector(state => state.caseEntity.canCreateEarhivaConfirmation);
  const {mutate: generateConfirmation, isPending: isGeneratingConfirmation} = generateEarhivaConfirmationQuery(uuid);

  return (
    <>
        {isGeneratingConfirmation && <FullScreenLoader />}
      <>
        <div className={'d-flex justify-content-between'}>
          {canCreateEarhivaConfirmation && (
            <Button
              label="Potvrda o evidentiranim podacima"
              size={'lg'}
              disabled={isGeneratingConfirmation}
              onClick={() => generateConfirmation()}
            />
          )}
        </div>
        <div className={'mt-3'}>
          <PreviewActsTable setActForAttachments={setIdCaseActForAttachments} setActAttachmentVariant={setActAttachmentVariant} />
        </div>
        <ActAttachmentModal idCaseAct={idCaseActForAttachments} type={actAttachmentVariant} setIdCaseAct={setIdCaseActForAttachments} />
      </>
    </>
  );
};

export default PreviewActs
